export const ServicerDisplayStatus = {
  A: 'Active',
  I: 'Inactive',
  S: 'Suspended'
};
